import React, { useState, useEffect } from "react";
import {
  Typography,
  Select,
  MenuItem,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Box,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import {
  Close,
  FormatBold,
  FormatItalic,
  FormatUnderlined,
} from "@mui/icons-material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
const SUPPORTED_FONTS = [
  { value: "Helvetica", label: "Helvetica" },
  { value: "Times-Roman", label: "Times Roman" },
  { value: "Courier", label: "Courier" },
];
const TextPropertiesPanel = ({
  selectedAnnotation,
  onUpdateAnnotation,
  type,
  setTextFieldMetrics,
  setAnnotationSettings,
  scale,
  closeButton,
}) => {
  const [textStyle, setTextStyle] = useState({
    fontSize: selectedAnnotation?.fontSize || 21,
    text: selectedAnnotation?.text,
    fontFamily: selectedAnnotation?.fontFamily || "Helvetica",
    format: selectedAnnotation?.format || [],
    isRequired: selectedAnnotation?.isRequired || false,
    fieldLabel: selectedAnnotation?.fieldLabel || "",
    width: selectedAnnotation?.width || 150,
    lineHeight: selectedAnnotation?.lineHeight || 1,
  });

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dateFormat, setDateFormat] = useState("MM/dd/yyyy");

  // Smaller font size range that better matches PDF output
  const FONT_SIZES = [8, 10, 12, 14, 16, 18, 20, 22, 24];
  // previous default
  // const FONT_SIZE_OPTIONS = [
  //   { label: "7", value: 14 },

  //   { label: "9", value: 16 },
  //   { label: "11", value: 18 },
  //   { label: "12", value: 20 },
  //   { label: "14", value: 22 },
  //   { label: "16", value: 24 },
  //   { label: "18", value: 26 },
  //   { label: "20", value: 28 },
  // ];
  const FONT_SIZE_OPTIONS = [
    { label: "7", value: 17 },

    { label: "9", value: 19 },
    { label: "11", value: 21 },
    { label: "12", value: 23 },
    { label: "14", value: 25 },
    { label: "16", value: 27 },
    { label: "18", value: 29 },
    { label: "20", value: 31 },
  ];
  useEffect(() => {
    if (selectedAnnotation) {
      setTextStyle({
        fontSize: selectedAnnotation?.fontSize || 21,
        fontFamily: selectedAnnotation?.fontFamily || "Helvetica",
        format: selectedAnnotation?.format || [],
        isRequired: selectedAnnotation?.isRequired || false,
        text: selectedAnnotation?.text || "", // Preserve text in state
        fieldLabel: selectedAnnotation?.fieldLabel || "",
        width: selectedAnnotation?.width || 150,
        lineHeight: selectedAnnotation?.lineHeight || 1,
      });
    }
  }, [selectedAnnotation, type]);
  // Add handler for required checkbox
  const handleRequiredChange = (event) => {
    const isRequired = event.target.checked;
    setTextStyle((prev) => ({
      ...prev,
      isRequired,
    }));

    onUpdateAnnotation({
      // ...selectedAnnotation,
      isRequired,
    });
  };

  const handleStyleChange = (property, value) => {
    setTextStyle((prevStyle) => ({
      ...prevStyle,
      [property]: value,
    }));

    if (!selectedAnnotation) return;

    // Directly call `onUpdateAnnotation` with only what changed
    onUpdateAnnotation({ [property]: value });
  };

  const handleFieldLabelChange = (event) => {
    const nextValue = event.target.value.slice(0, 120);
    setTextStyle((prevStyle) => ({
      ...prevStyle,
      fieldLabel: nextValue,
    }));
    onUpdateAnnotation({ fieldLabel: nextValue });
  };

  const handleFieldLabelBlur = () => {
    const trimmed = (textStyle.fieldLabel || "").trim();
    if (trimmed !== textStyle.fieldLabel) {
      setTextStyle((prevStyle) => ({
        ...prevStyle,
        fieldLabel: trimmed,
      }));
    }
    onUpdateAnnotation({ fieldLabel: trimmed });
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#ffffff",
          width: "100%",
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          "& .MuiTypography-body2": {
            fontSize: "13px",
            color: "rgba(0, 0, 0, 0.7)",
            mb: 1,
            whiteSpace: "nowrap",
          },
          "& .MuiTypography-h6": {
            whiteSpace: "nowrap",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2.5,
            mt: 1,
            // px: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: "rgba(0, 0, 0, 0.87)",
              // mb: 2.5,
              width: "100%",
            }}
          >
            Text
          </Typography>

          <Close
            style={{
              cursor: "pointer !important",
              color: "rgba(0, 0, 0, 0.54)",
              "&:hover": {
                color: "rgba(0, 0, 0, 0.87)",
                cursor: "pointer !important",
              },
              fontSize: "20px",
            }}
            onClick={closeButton}
          />
        </Box>
        {/* Add Required checkbox for signer annotations */}
        {selectedAnnotation?.type?.startsWith("signer_") && (
          <Box
            sx={{
              mt: 1,
              display: "flex",
              justifyContent: "left",
              width: "100%",
              cursor: "pointer",
            }}
          >
            <FormControlLabel
              sx={{
                margin: 0, // Remove default margin
                "& .MuiFormControlLabel-label": {
                  margin: 0,
                  cursor: "pointer",
                },
              }}
              control={
                <Checkbox
                  checked={textStyle.isRequired}
                  onChange={handleRequiredChange}
                  size="small"
                  sx={{
                    color: "rgba(0, 0, 0, 0.54)",
                    "&.Mui-checked": {
                      color: "rgb(0, 145, 255)",
                    },
                    // padding: "4px",
                  }}
                />
              }
              label={
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "13px",
                    color: "rgba(0, 0, 0, 0.7)",
                    mt: 1.5,
                  }}
                >
                  Required
                </Typography>
              }
            />
          </Box>
        )}
        {/* Font Family */}
        {selectedAnnotation?.type === "signer_text" && (
          <>
            <Typography variant="body2">Label</Typography>
            <TextField
              value={textStyle.fieldLabel}
              onChange={handleFieldLabelChange}
              onBlur={handleFieldLabelBlur}
              placeholder="Cardholder Full Name"
              inputProps={{ maxLength: 120 }}
              size="small"
              fullWidth
              sx={{
                mb: 2.5,
                "& .MuiOutlinedInput-root": {
                  "& .MuiOutlinedInput-input": {
                    py: 1,
                    fontSize: "14px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 145, 255, 0.5)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgb(0, 145, 255)",
                  },
                },
              }}
            />
          </>
        )}

        {/* Font Family */}

        <Typography variant="body2">Font Family</Typography>
        <FormControl fullWidth size="small" sx={{ mb: 2.5, minWidth: "100%" }}>
          <Select
            value={textStyle.fontFamily}
            onChange={(e) => handleStyleChange("fontFamily", e.target.value)}
            sx={{
              "& .MuiSelect-select": {
                py: 1,
                fontSize: "14px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 145, 255, 0.5)",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgb(0, 145, 255)",
              },
            }}
          >
            {SUPPORTED_FONTS.map((font) => (
              <MenuItem
                key={font.value}
                value={font.value}
                sx={{
                  fontSize: "14px",
                  // py: 1,
                  fontFamily: font.value,
                  "&:hover": {
                    backgroundColor: "rgba(0, 145, 255, 0.08)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(0, 145, 255, 0.16)",
                    "&:hover": {
                      backgroundColor: "rgba(0, 145, 255, 0.24)",
                    },
                  },
                }}
              >
                {font.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Font Size Dropdown */}
        <Typography variant="body2">Font Size</Typography>
        <FormControl fullWidth size="small" sx={{ mb: 2.5 }}>
          <Select
            value={textStyle.fontSize}
            onChange={(e) => handleStyleChange("fontSize", e.target.value)}
            sx={{
              "& .MuiSelect-select": {
                py: 1,
                fontSize: "14px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 145, 255, 0.5)",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgb(0, 145, 255)",
              },
            }}
          >
            {FONT_SIZE_OPTIONS.map((size) => (
              <MenuItem
                key={size.value}
                value={size.value}
                sx={{
                  fontSize: "14px",
                  py: 1,
                  "&:hover": {
                    backgroundColor: "rgba(0, 145, 255, 0.08)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(0, 145, 255, 0.16)",
                    "&:hover": {
                      backgroundColor: "rgba(0, 145, 255, 0.24)",
                    },
                  },
                }}
              >
                {size.label}px
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Reset Font Size Button */}
        <Button
          variant="outlined"
          size="small"
          fullWidth
          onClick={() => {
            const defaultFontSize = 21; // Default font size
            // Reset both font size and width
            onUpdateAnnotation({
              fontSize: defaultFontSize,
              width: undefined, // Let it recalculate based on text and new font size
            });
          }}
          sx={{
            mb: 2.5,
            py: 1,
            textTransform: "none",
            borderColor: "rgba(0, 0, 0, 0.23)",
            color: "rgba(0, 0, 0, 0.87)",
            "&:hover": {
              borderColor: "rgba(0, 145, 255, 0.5)",
              backgroundColor: "rgba(0, 145, 255, 0.08)",
            },
          }}
        >
          Reset to Default (21px)
        </Button>

        {/* Line Height - Hidden for now */}
        {/* <Typography variant="body2">Line Height</Typography>
        <TextField
          type="number"
          value={textStyle.lineHeight}
          onChange={(e) => {
            const value = parseFloat(e.target.value) || 1;
            handleStyleChange("lineHeight", value);
          }}
          inputProps={{
            min: 1,
            max: 3,
            step: 0.1,
          }}
          size="small"
          fullWidth
          sx={{
            mb: 2.5,
            "& .MuiOutlinedInput-root": {
              "& .MuiOutlinedInput-input": {
                py: 1,
                fontSize: "14px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 145, 255, 0.5)",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgb(0, 145, 255)",
              },
            },
          }}
        /> */}

        {/* Text Format – vertical stack on small screens like left sidebar */}
        <Typography variant="body2">Text Style</Typography>
        <ToggleButtonGroup
          value={textStyle.format}
          onChange={(e, newFormats) => handleStyleChange("format", newFormats)}
          size="small"
          fullWidth
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "stretch",
            "& .MuiToggleButton-root": {
              py: 1,
              border: "1px solid rgba(0, 0, 0, 0.12)",
              "&.Mui-selected": {
                backgroundColor: "rgba(0, 145, 255, 0.08)",
                color: "rgb(0, 145, 255)",
                "&:hover": {
                  backgroundColor: "rgba(0, 145, 255, 0.12)",
                },
              },
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            },
            "& .MuiSvgIcon-root": {
              fontSize: "20px",
            },
          }}
        >
          <ToggleButton value="bold">
            <FormatBold />
          </ToggleButton>
          <ToggleButton value="italic">
            <FormatItalic />
          </ToggleButton>
          <ToggleButton value="underline">
            <FormatUnderlined />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </>
  );
};

export default TextPropertiesPanel;
